export default __webpack_public_path__ + "static/media/PNG.6a7ba961.png";